const readImportMetaEnv = () => {
  return globalThis?.__VITE_ENV__ || {};
};

export const getRuntimeEnv = (key, fallback = "") => {
  const viteValue = readImportMetaEnv()?.[key];
  if (viteValue !== undefined && viteValue !== null && viteValue !== "") {
    return viteValue;
  }

  const nodeEnv = typeof process !== "undefined" ? process.env : undefined;
  const nextPublicValue = nodeEnv?.[`NEXT_PUBLIC_${key.replace(/^VITE_/, "")}`];
  if (nextPublicValue !== undefined && nextPublicValue !== null && nextPublicValue !== "") {
    return nextPublicValue;
  }

  return fallback;
};

export const isRuntimeDev = () =>
  String(
    getRuntimeEnv(
      "MODE",
      (typeof process !== "undefined" ? process.env?.NODE_ENV : undefined) || "development"
    )
  ) !== "production";

export const isRuntimeProd = () => !isRuntimeDev();
